import { useEffect, useMemo } from 'react';

import { useModuleTagging } from '@suntex.fim/framework';
import { ModuleFilter, buildModuleEnabledPredicate } from '@suntex.fim/hub';

export function ModuleAccessGuard({
  moduleSlug,
  enable,
  disable,
  onInvalidAccess,
}: {
  moduleSlug: string;
  enable: ModuleFilter;
  disable: ModuleFilter;
  onInvalidAccess: () => void;
}) {
  const { moduleTagging, isLoading } = useModuleTagging();

  const isModuleEnabled = useMemo(
    () =>
      moduleTagging
        ? buildModuleEnabledPredicate({
            moduleTagging,
            enable,
            disable,
          })
        : () => false, // Deny access while loading to prevent bypass
    [moduleTagging, enable, disable],
  );

  useEffect(() => {
    // Check access once module tagging is loaded
    if (!isLoading && !isModuleEnabled(moduleSlug)) {
      onInvalidAccess();
    }
  }, [isModuleEnabled, moduleSlug, onInvalidAccess, isLoading]);

  return <></>;
}
